import ValueWithPrecision from './ValueWithPrecision';

export default ValueWithPrecision;
